export default {
      id: "map-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#map",
      toString: function () {
        return this.url;
      }
    }